import styled from 'styled-components'
import { print } from '../styles'
import {
  compose,
  space,
  layout,
  typography,
  color,
  flexbox,
  grid,
  background,
  border,
  position,
} from 'styled-system'

const SimpleTable = styled.table`
  ${print}

  width: 100%;
  table-layout: fixed;

  ${compose(space, layout, typography, color, flexbox, grid, background, border, position)}

  border-collapse: separate;
  border-spacing: 0 ${({ theme, spacing }) => theme.space[spacing] || theme.space.xsmall}px;
`

export default SimpleTable
